import "../sentry-error-handler";
import "../analytics-boot";
import { loadReactContext } from "../react-context";
import SessionRouter from "../session/SessionRouter";
import "@/assets/stylesheets/session_app.scss";
import "../stylesheets/global-style.scss";

loadReactContext({ SessionRouter });
